import { render, staticRenderFns } from "./McCard.vue?vue&type=template&id=4f2f47a5&scoped=true&"
import script from "./McCard.vue?vue&type=script&lang=js&"
export * from "./McCard.vue?vue&type=script&lang=js&"
import style0 from "./McCard.vue?vue&type=style&index=0&id=4f2f47a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f47a5",
  null
  
)

export default component.exports